import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { connect, ConnectedProps } from 'react-redux';
import { notificationSelected } from '../../../navigation/notification/state/actions';

const mapDispatch = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  markNotificationAsRead(notificationId: number) {
    dispatch(notificationSelected(notificationId));
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
